import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import {
  deleteCollege,
  getCities,
  getColleges,
  getCountries,
  getDistricts,
  getStates,
  getUniversities,
  updateApprovalForInstitution,
  updateCollege,
} from "../../Services/HomeService";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { createSlug, getPlainTextFromHtml } from "../../utils/Helper";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import HttpClientXml from "../../utils/HttpClientXml";
import { useNavigate } from "react-router-dom";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};
const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};
const customStyles = {
  headCells: {
    style: {
      fontSize: "15px",
      fontWeight: "bold",
      color: "#333",
    },
  },
};

const ManageCollegeUniversity = () => {
  const frontendURL = "http://13.233.195.89:3330";
  // const frontendURL = "http://52.66.207.187:3330";
  // const frontendURL = "http://localhost:5173"

  const navigate = useNavigate();
  const [colleges, setColleges] = useState([]);
  const [fetchCollegesLoading, setFetchCollegesLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [fetchStatesLoading, setFetchStatesLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [fetchDistrictsLoading, setFetchDistrictsLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [fetchCitiesLoading, setFetchCitiesLoading] = useState(false);
  const [universities, setUniversities] = useState([]);
  const [fetchUniversitiesLoading, setFetchUniversitiesLoading] =
    useState(false);
  const [countries, setCountries] = useState([]);
  const [fetchCountriesLoading, setFetchCountriesLoading] = useState(false);
  const fileBrouchureInputRef = useRef(null);
  const filePhotoInputRef = useRef(null);
  const [uploadingBrouchure, setUploadingBrouchure] = useState(false);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);

  const fetchColleges = async () => {
    try {
      setFetchCollegesLoading(true);
      const res = await getColleges();
      console.log("fetched Colleges", res?.data);
      if (res?.status) {
        setColleges(res?.data);
        setFilteredData(res?.data);
        setFetchCollegesLoading(false);
      } else {
        toast.error("Error while Fetching College Data");
        setFetchCollegesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch College Data");
      console.error("Error fetching College:", error);
      setFetchCollegesLoading(false);
    }
  };

  const fetchCountries = async () => {
    try {
      setFetchCountriesLoading(true);
      const res = await getCountries();
      console.log("fetched counries", res);
      if (res?.status) {
        setCountries(res?.data);
        setFetchCountriesLoading(false);
      } else {
        toast.error("Error while Fetching Counries Data");
        setFetchCountriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Counries Data");
      console.error("Error fetching Counries:", error);
      setFetchCountriesLoading(false);
    }
  };

  const fetchStates = async (country) => {
    try {
      setFetchStatesLoading(true);
      const res = await getStates();
      console.log("fetched states", res);
      if (res?.status) {
        setStates(res?.data.filter((item) => item.country._id === country));
        setFetchStatesLoading(false);
      } else {
        toast.error("Error while Fetching States Data");
        setFetchStatesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch States Data");
      console.error("Error fetching State:", error);
      setFetchStatesLoading(false);
    }
  };

  const fetchDistricts = async (stateId) => {
    try {
      setFetchDistrictsLoading(true);
      const res = await getDistricts();
      console.log("fetched districts", res?.data);
      if (res?.status) {
        setDistricts(res?.data.filter((item) => item.stateId === stateId));
        setFetchDistrictsLoading(false);
      } else {
        toast.error("Error while Fetching Districts Data");
        setFetchDistrictsLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Districts Data");
      console.error("Error fetching Districts:", error);
      setFetchDistrictsLoading(false);
    }
  };

  const fetchCities = async (districtId) => {
    try {
      setFetchCitiesLoading(true);
      const res = await getCities();
      console.log("fetched Cities", res?.data, districtId);
      if (res?.status) {
        setCities(
          res?.data.filter((item) => item?.district?._id === districtId)
        );
        setFetchCitiesLoading(false);
      } else {
        toast.error("Error while Fetching Cities Data");
        setFetchCitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Cities Data");
      console.error("Error fetching Districts:", error);
      setFetchCitiesLoading(false);
    }
  };

  const fetchUniversities = async () => {
    try {
      setFetchUniversitiesLoading(true);
      const res = await getUniversities();
      console.log("fetched Universities", res);
      if (res?.status) {
        setUniversities(res?.data);
        setFetchUniversitiesLoading(false);
      } else {
        toast.error("Error while Fetching Universities Data");
        setFetchUniversitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Universities Data");
      console.error("Error fetching Universities:", error);
      setFetchUniversitiesLoading(false);
    }
  };

  // const data = [
  //   {
  //     state: "West Bangal",
  //     district: "North 24 Parganas",
  //     cityName: "Madhyamgram",
  //     type: "college",
  //     universityName: "Sikkim Manipal University",
  //     name: "Lee Sun College",
  //     shortDescription: "This is a good college",
  //     //   state: "West Bengal",
  //     //   district: "North 24 Parganas",
  //     address: "Barasat",
  //     pin: "700155",
  //     privateOrGovt: "Govt",
  //     estd: "1990",
  //     longDescription:
  //       "hello hello hello hello hello hello hello hello hello hello hello hello hello hello hello hello ",
  //   },
  // ];

  const initialValues = {
    type: "",
    parentUniversity: "",
    name: "",
    shortDescription: "",
    longDescription: "",
    stateId: "",
    districtId: "",
    cityId: "",
    address: "",
    pinCode: "",
    estd: "",
    institutionType: "",
    countryId: "",
    isAbroad: false,
    collegeBrochure: "",
    collegeImage: "",
    seoFriendlyName: "",
  };

  let a = false;

  const [updateCollegeLoading, setUpdateCollegeLoading] = useState(false);

  const [updateId, setUpdateId] = useState("");
  const [updateFormData, setUpdateFormData] = useState(initialValues);

  const handleEdit = (data) => {
    console.log("KJU165", data);
    setUpdateId(data?._id);
    // countryId
    fetchStates(data?.country?._id || "");
    fetchDistricts(data?.state?._id || "");
    fetchCities(data?.district?._id || "");

    const displayData = {
      type: data?.type || "",
      parentUniversity: data?.parentUniversity?._id,
      name: data?.name || "",
      shortDescription: data?.shortDescription || "",
      longDescription: data?.longDescription || "",
      stateId: data?.state?._id || "",
      districtId: data?.district?._id || "",
      cityId: data?.city?._id || "",
      address: data?.address || "",
      pinCode: parseInt(data?.pinCode) || "",
      estd: parseInt(data?.estd) || "",
      institutionType: data?.institutionType || "",
      countryId: data?.country?._id || "",
      isAbroad: data?.isAbroad,
      collegeImage: data?.collegeImage,
      collegeBrochure: data?.collegeBrochure,
    };
    setUpdateFormData(displayData);
  };

  const handleCollegeCourses = (data) => {
    navigate("/manage-course-and-fees", {
      state: { college: { collegeid: data?._id, collegename: data?.name } },
    });
  };

  const handleOverview = (data) => {
    navigate("/college-university-overview", {
      state: { college: data?._id },
    });
  };

  const handleCoursesFees = (data) => {
    navigate("/college-university-coursesfees", {
      state: { college: data?._id },
    });
  };

  const handleAdmission = (data) => {
    console.log("KJU165", data);
    navigate("/college-university-admission", {
      state: { college: data?._id },
    });
  };

  const handleScholarship = (data) => {
    navigate("/college-university-scholarship", {
      state: { college: data?._id },
    });
  };

  const handlePlacement = (data) => {
    navigate("/college-university-placement", {
      state: { college: data?._id },
    });
  };

  const handleCutOffs = (data) => {
    navigate("/college-university-cutoffs", {
      state: { college: data?._id },
    });
  };

  const handleRanking = (data) => {
    navigate("/college-university-ranking", {
      state: { college: data?._id },
    });
  };

  const handleCampus = (data) => {
    navigate("/college-university-campus", {
      state: { college: data?._id },
    });
  };

  const handleGallery = (data) => {
    navigate("/manage-gallery", {
      state: { college: data?._id },
    });
  };

  const handleFees = (data) => {
    navigate("/college-university-fees", {
      state: { college: data?._id },
    });
  };

  const columns = [
    {
      name: "SL.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      minWidth: "30px",
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
              onClick={() => handleEdit(row)}
            ></i>
          </span>
          {/* <span title="Delete">
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
              onClick={() => handleDelete(row?._id)}
            ></i>
          </span> */}
        </>
      ),
      minWidth: "25px",
    },

    // {
    //   name: "Type",
    //   selector: (row) => row?.type,
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "Abroad",
    //   selector: (row) => row?.isAbroad ? "Yes" : "No",
    //   sortable: true,
    //   wrap: true,
    // },
    {
      name: "University",
      selector: (row) => row?.parentUniversity?.name,
      sortable: true,
      wrap: true,
      minWidth: "250px",
    },
    {
      name: "College/University",
      selector: (row) => (
        <>
          {row?.name}&nbsp;
          <a href={`${frontendURL}/${row?.seoFriendlyName}`} target="_blank">
            <i className="fa-solid fa-arrow-up-right-from-square"></i>
          </a>
        </>
      ),
      sortable: true,
      wrap: true,
      minWidth: "250px",
    },
    // {
    //   name: "Link",
    //   selector: (row) => row?.seoFriendlyName,
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "Short Description",
    //   selector: (row) => row?.shortDescription,
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "Country",
    //   selector: (row) => row?.country?.countryName,
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "State",
    //   selector: (row) => row?.state?.stateName,
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "District",
    //   selector: (row) => row?.district?.districtName,
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "City",
    //   selector: (row) => row?.city?.cityName,
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "Address",
    //   selector: (row) => row?.address,
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "PIN",
    //   selector: (row) => row?.pinCode,
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: "Administration",
    //   selector: (row) => row?.institutionType,
    //   sortable: true,
    //   wrap: true,
    // },
    {
      name: "Location",
      selector: (row) => (
        <>
          {row?.isAbroad
            ? `Abroad`
            : `${row?.district?.districtName} (${row?.state?.stateName})`}
        </>
      ),
      sortable: true,
      wrap: true,
      minWidth: "250px",
    },
    // {
    //   name: "ESTD",
    //   selector: (row) => row?.estd,
    //   sortable: true,
    //   center: true,
    // },
    // {
    //   name: "Long Description",
    //   selector: (row) => { return getPlainTextFromHtml(row?.longDescription) },
    //   sortable: true,
    //   wrap: true,
    // },
    {
      name: "Courses",
      center: true,
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-success"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handleCollegeCourses(row)}
          >
            Courses
          </button>
        </>
      ),
      minWidth: "100px",
    },
    {
      name: "Tab Management",
      center: true,
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-success"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handleOverview(row)}
          >
            Overview
          </button>
          <button
            className="btn btn-sm btn-success ml-2"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handleCoursesFees(row)}
          >
            Course & Fees
          </button>
          <button
            className="btn btn-sm btn-success ml-2"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handleAdmission(row)}
          >
            Admission
          </button>
          <button
            className="btn btn-sm btn-success ml-2"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handleScholarship(row)}
          >
            Scholarship
          </button>
          <button
            className="btn btn-sm btn-success ml-2"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handlePlacement(row)}
          >
            Placement
          </button>
          <br />
          <button
            className="btn btn-sm btn-success ml-2"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handleCutOffs(row)}
          >
            CutOffs
          </button>
          <button
            className="btn btn-sm btn-success ml-2"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handleRanking(row)}
          >
            Ranking
          </button>
          <button
            className="btn btn-sm btn-success ml-2"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handleCampus(row)}
          >
            Campus
          </button>
          <button
            className="btn btn-sm btn-success ml-2"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handleGallery(row)}
          >
            Gallery
          </button>
          <button
            className="btn btn-sm btn-success ml-2"
            style={{ minWidth: "100px" }}
            type="button"
            onClick={() => handleFees(row)}
          >
            Fees
          </button>
        </>
      ),
      minWidth: "1200px",
    },
    {
      name: "Approval",
      selector: (row) => (
        <div>
          {row?.isApproved ? (
            <button
              onClick={() => {
                changeApproval(row?._id);
              }}
              style={{
                padding: "5px 10px",
                borderRadius: "5px",
                backgroundColor: "green",
                color: "white",
                border: "none",
              }}
            >
              Approved
            </button>
          ) : (
            <button
              onClick={() => {
                changeApproval(row?._id);
              }}
              style={{
                padding: "5px 10px",
                borderRadius: "5px",
                backgroundColor: "red",
                color: "white",
                border: "none",
              }}
            >
              Disapproved
            </button>
          )}
        </div>
      ),
      center: true,
      width: "150px",
    },
  ];

  // const changeApproval = async (id) => {

  //   const res = await updateApprovalForInstitution(id);
  //   if (res?.status){
  //     const obj = universities?.map((e,i)=>{
  //       if(e?._id === id){
  //         e?.isApproved = !e?.isApproved
  //       }
  //     })
  //     toast?.success(res?.data?.message)
  //   }else{
  //     toast?.error(res?.data?.message)
  //   }

  // };
  const [approvedToggle, setApprovedToggle] = useState(null);
  const changeApproval = async (id) => {
    const res = await updateApprovalForInstitution(id);
    console.log(res);
    if (res?.status) {
      const updated = filteredData?.map((e) =>
        e?._id === id ? { ...e, isApproved: !e.isApproved } : e
      );

      setFilteredData(updated); // <-- React state update

      toast.success(res?.message);
    } else {
      toast.error(res?.message);
    }
  };

  const handleCancel = () => {
    setUpdateId(null);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete College/University?",
      text: "Are you sure you want to delete this College/University?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteCollege(id);
        Swal.fire(
          "Deleted!",
          "College/University has been deleted.",
          "success"
        );
        fetchColleges();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete College/University.", "error");
      }
    }
  };

  const handleUpdate = async (e) => {
    e?.preventDefault();
    if (
      !updateFormData?.type ||
      !updateFormData?.parentUniversity ||
      !updateFormData?.stateId ||
      !updateFormData?.cityId ||
      !updateFormData?.name ||
      !updateFormData?.address ||
      !updateFormData?.districtId ||
      !updateFormData?.institutionType ||
      !updateFormData?.estd ||
      !updateFormData?.longDescription ||
      !updateFormData?.shortDescription ||
      !updateFormData?.pinCode
    ) {
      toast.error("Please Enter All Fields");
      return;
    }
    const formData = {
      ...updateFormData,
      seoFriendlyName: createSlug(updateFormData?.name),
    };
    console.log("CFG497", formData);
    // return
    try {
      setUpdateCollegeLoading(true);
      const res = await updateCollege(updateId, formData);
      console.log("College Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setUpdateFormData(initialValues);
        setUpdateId(null);
        setUpdateCollegeLoading(false);
        // navigate("/college-university-overview", {
        //   state: { college: res?.data?._id }
        // });
      } else {
        toast.error(res?.message);
        setUpdateCollegeLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setUpdateCollegeLoading(false);
    } finally {
      fetchColleges();
    }
  };

  const handleBrouchureUpload = async (e) => {
    e.preventDefault();
    setUploadingBrouchure(true);
    const data = new FormData();
    data.append("file", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("file-upload", "POST", data);
      console.log("VFR235", res);

      if (res?.image) {
        setUpdateFormData({ ...updateFormData, collegeBrochure: res.image });
        toast.success("Brouchure uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploadingBrouchure(false);
      fileBrouchureInputRef.current.value = null;
    }
  };

  const handlePhotoUpload = async (e) => {
    e.preventDefault();
    setUploadingPhoto(true);
    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      console.log("VFR258", res);

      if (res?.image) {
        setUpdateFormData({ ...updateFormData, collegeImage: res.image });
        toast.success("Photo uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploadingPhoto(false);
      filePhotoInputRef.current.value = null;
    }
  };

  useEffect(() => {
    fetchColleges();
    fetchCountries();
    fetchStates();
    fetchUniversities();
  }, []);

  useEffect(() => {
    fetchStates(updateFormData?.countryId);
    setCities([]);
  }, [updateFormData?.countryId]);

  useEffect(() => {
    fetchDistricts(updateFormData?.stateId);
    setCities([]);
  }, [updateFormData?.stateId]);

  useEffect(() => {
    fetchCities(updateFormData?.districtId);
  }, [updateFormData?.districtId]);

  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState(colleges);

  useEffect(() => {
    const filteredData = colleges.filter((item) => {
      return (
        item?.parentUniversity?.name
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        item?.name?.toLowerCase().includes(search.toLowerCase()) ||
        item?.district?.districtName
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        item?.state?.stateName?.toLowerCase().includes(search.toLowerCase())
      );
    });
    if (search.trim()) {
      setFilteredData(filteredData);
    } else {
      setFilteredData(colleges);
    }
  }, [search]);

  return (
    <div>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Manage College or University
          </div>
          {updateId ? (
            <>
              <section className="chartBox_area">
                <form
                  onSubmit={(e) => {
                    handleUpdate(e);
                  }}
                >
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-2 mt-3">
                      <label htmlFor="name">
                        Choose Type<span className="text-danger">*</span>
                      </label>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px", // spacing between radio options
                          alignItems: "center",
                          marginTop: "8px",
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <input
                            type="radio"
                            name="college"
                            value="College"
                            checked={updateFormData?.type === "College"}
                            onChange={(e) =>
                              setUpdateFormData((prev) => ({
                                ...prev,
                                type: e?.target?.value,
                              }))
                            }
                          />
                          College
                        </label>

                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <input
                            type="radio"
                            name="college"
                            value="University"
                            checked={updateFormData?.type === "University"}
                            onChange={(e) =>
                              setUpdateFormData((prev) => ({
                                ...prev,
                                type: e?.target?.value,
                              }))
                            }
                          />
                          University
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2 mt-3">
                      <label htmlFor="name">
                        Choose <span className="text-danger">*</span>
                      </label>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          alignItems: "center",
                          marginTop: "8px",
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <input
                            type="radio"
                            name="govt"
                            value="Private"
                            checked={
                              updateFormData?.institutionType === "Private"
                            }
                            onChange={(e) =>
                              setUpdateFormData((prev) => ({
                                ...prev,
                                institutionType: e.target.value,
                              }))
                            }
                          />
                          Private
                        </label>

                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <input
                            type="radio"
                            name="govt"
                            value="Government"
                            checked={
                              updateFormData?.institutionType === "Government"
                            }
                            onChange={(e) =>
                              setUpdateFormData((prev) => ({
                                ...prev,
                                institutionType: e.target.value,
                              }))
                            }
                          />
                          Government
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2 mt-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="isAbroad"
                          className="form-check-input"
                          checked={updateFormData?.isAbroad || false}
                          onChange={(e) => {
                            setUpdateFormData((prev) => ({
                              ...prev,
                              isAbroad: e.target.checked,
                            }));
                          }}
                        />
                        <label htmlFor="isAbroad" className="form-check-label">
                          Abroad
                        </label>
                      </div>
                    </div>

                    <div
                      className="col-md-6 mt-3"
                      // style={{
                      //   display:
                      //     updateFormData?.type === "College" ? "" : "none",
                      // }}
                    >
                      <label htmlFor="name">
                        University Name<span className="text-danger">*</span>
                      </label>
                      <select
                        onChange={(e) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            parentUniversity: e?.target?.value,
                          }));
                        }}
                        value={updateFormData?.parentUniversity}
                        className="form-control"
                      >
                        <option value="">
                          -------- Select University --------
                        </option>
                        {fetchUniversitiesLoading ? (
                          <option>Loading...</option>
                        ) : universities?.length === 0 ? (
                          <option>No University Found</option>
                        ) : (
                          universities?.map((e, i) => {
                            return (
                              <option key={i} value={e?._id}>
                                {e?.name}
                              </option>
                            );
                          })
                        )}
                      </select>
                    </div>
                    <div className="col-md-10 mt-3">
                      <label htmlFor="name">
                        Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        className="form-control"
                        value={updateFormData?.name}
                        onChange={(e) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            name: e?.target?.value,
                          }));
                        }}
                        placeholder="Enter Name"
                        required
                      />
                    </div>
                    <div className="col-md-2 mt-3">
                      <label htmlFor="name">
                        ESTD<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        className="form-control"
                        value={updateFormData?.estd}
                        onChange={(e) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            estd: Number(e?.target?.value),
                          }));
                        }}
                        placeholder="Enter ESTD Year"
                        required
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <label htmlFor="name">
                        Short Description<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        className="form-control"
                        value={updateFormData?.shortDescription}
                        onChange={(e) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            shortDescription: e?.target?.value,
                          }));
                        }}
                        placeholder="Short Description"
                        required
                      />
                    </div>
                    <div
                      className="col-md-12 mt-3"
                      style={{ marginBottom: "-15px" }}
                    >
                      <label style={{ fontSize: "24px", fontWeight: "600" }}>
                        Address
                      </label>
                    </div>
                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        Country<span className="text-danger">*</span>
                      </label>
                      <select
                        required
                        className="form-control"
                        onChange={(e) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            countryId: e?.target?.value,
                          }));
                        }}
                        value={updateFormData?.countryId}
                      >
                        <option value="">
                          -------- Select Country --------
                        </option>
                        {fetchCountriesLoading ? (
                          <option>Loading...</option>
                        ) : countries?.length === 0 ? (
                          <option disabled>No Country Found</option>
                        ) : (
                          countries?.map((e, i) => {
                            return (
                              <option key={i} value={e?._id}>
                                {e?.countryName}
                              </option>
                            );
                          })
                        )}
                      </select>
                    </div>
                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        State Name<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={updateFormData?.stateId}
                        onChange={(e) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            stateId: e?.target?.value,
                          }));
                        }}
                      >
                        <option value="">-------- Select State --------</option>
                        {fetchStatesLoading ? (
                          <option>Loading...</option>
                        ) : states?.length === 0 ? (
                          <option disabled>No State Found</option>
                        ) : (
                          states?.map((e, i) => {
                            return (
                              <option key={i} value={e?._id}>
                                {e?.stateName}
                              </option>
                            );
                          })
                        )}
                      </select>
                    </div>
                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        District Name<span className="text-danger">*</span>
                      </label>
                      <select
                        disabled={!updateFormData?.stateId}
                        className="form-control"
                        value={updateFormData?.districtId}
                        onChange={(e) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            districtId: e?.target?.value,
                          }));
                        }}
                      >
                        <option value="">
                          -------- Select District --------
                        </option>
                        {fetchDistrictsLoading ? (
                          <option>Loading...</option>
                        ) : districts?.length === 0 ? (
                          <option disabled>No District Found</option>
                        ) : (
                          districts?.map((e, i) => {
                            if (e?.state?._id === updateFormData?.stateId) {
                              a = true;
                              return (
                                <option key={i} value={e?._id}>
                                  {e?.districtName}
                                </option>
                              );
                            }
                          })
                        )}
                      </select>
                    </div>
                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        City Name<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={updateFormData?.cityId}
                        disabled={!updateFormData?.districtId}
                        onChange={(e) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            cityId: e?.target?.value,
                          }));
                        }}
                      >
                        <option value="">-------- Select City --------</option>
                        {fetchCitiesLoading ? (
                          <option>Loading...</option>
                        ) : cities?.length === 0 ? (
                          <option disabled>No City Found</option>
                        ) : (
                          cities?.map((e, i) => {
                            return (
                              <option key={i} value={e?._id}>
                                {e?.cityName}
                              </option>
                            );
                          })
                        )}
                      </select>
                    </div>
                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        Address<span className="text-danger">*</span>
                      </label>
                      <textarea
                        style={{ resize: "none" }}
                        type="text"
                        id="name"
                        className="form-control"
                        value={updateFormData?.address}
                        onChange={(e) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            address: e?.target?.value,
                          }));
                        }}
                        placeholder="Enter Address"
                        required
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        PIN Code<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        className="form-control"
                        value={updateFormData?.pinCode}
                        onChange={(e) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            pinCode: Number(e?.target?.value),
                          }));
                        }}
                        placeholder="Enter PIN"
                        required
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="Brochure">
                        {uploadingBrouchure && "Uploading "}Brochure
                        {/*<span className="text-danger">*</span> */}
                      </label>
                      {!uploadingBrouchure &&
                        updateFormData?.collegeBrochure && (
                          <>
                            {/* <img
                      src={formData?.brochure}
                      alt="Brochure Preview"
                      style={{ display: "block", margin: "10px 0", maxHeight: "100px" }}
                    /> */}
                            <a
                              href={updateFormData?.collegeBrochure}
                              target="_blank"
                              style={{ marginLeft: "10px" }}
                            >
                              {updateFormData?.collegeBrochure
                                .split(".")
                                .pop()
                                .toLowerCase() === "pdf" ? (
                                <i className="fas fa-2x fa-file-pdf" />
                              ) : (
                                updateFormData?.collegeBrochure
                                  .split(".")
                                  .pop()
                                  .toLowerCase() === "doc" ||
                                (updateFormData?.collegeBrochure
                                  .split(".")
                                  .pop()
                                  .toLowerCase() === "docx" && (
                                  <i className="fas fa-2x fa-file-word" />
                                ))
                              )}
                            </a>
                          </>
                        )}
                      <input
                        type="file"
                        ref={fileBrouchureInputRef}
                        className="form-control"
                        onChange={handleBrouchureUpload}
                        // accept="image/*,.pdf,.doc,.docx"
                        accept=".pdf,.doc,.docx"
                        // required
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="Brochure">
                        {uploadingPhoto && "Uploading "}Photo
                        {/*<span className="text-danger">*</span> */}
                      </label>
                      {!uploadingPhoto && updateFormData?.collegeImage && (
                        <>
                          <img
                            src={updateFormData?.collegeImage}
                            alt="Photo Preview"
                            style={{
                              display: "block",
                              margin: "10px 0",
                              maxHeight: "100px",
                            }}
                          />
                        </>
                      )}
                      <input
                        type="file"
                        ref={filePhotoInputRef}
                        className="form-control"
                        onChange={handlePhotoUpload}
                        accept="image/*"
                        // required
                      />
                    </div>

                    {/* <div className="col-md-12 mt-3">
                        <label htmlFor="name">
                          Long Description<span className="text-danger">*</span>
                        </label>
                        <textarea
                          style={{ resize: "none" }}
                          type="text"
                          id="name"
                          className="form-control"
                          value={updateFormData?.longDescription}
                          onChange={(e) => {
                            setUpdateFormData((prev) => ({
                              ...prev,
                              longDescription: e?.target?.value,
                            }));
                          }}
                          placeholder="Enter Description"
                          required
                        />
                      </div> */}
                    <div className="col-md-12 mt-3">
                      <label htmlFor="longDescription">
                        Long Description<span className="text-danger">*</span>
                      </label>
                      <ReactQuill
                        modules={modules}
                        id="longDescription"
                        theme="snow"
                        value={updateFormData?.longDescription || ""}
                        onChange={(value) => {
                          setUpdateFormData((prev) => ({
                            ...prev,
                            longDescription: value,
                          }));
                        }}
                        placeholder="Enter Long Description"
                        style={{
                          height: "150px",
                          marginBottom: "40px",
                          fontFamily: "Poppins",
                          fontSize: "22px",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className=" d-flex justify-content-end"
                    style={{ gap: "15px" }}
                  >
                    <button
                      onClick={() => {
                        handleCancel();
                      }}
                      disabled={updateCollegeLoading}
                      type="button"
                      className="btn mt-3"
                      style={{
                        background: "#f77754",
                        borderRadius: "13px",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      disabled={updateCollegeLoading}
                      type="submit"
                      className="btn mt-3"
                      style={{
                        background: "rgb(133, 218, 79)",
                        borderRadius: "13px",
                      }}
                    >
                      {
                        updateCollegeLoading ? "Loading..." : "Update"
                        // : "Next"
                      }
                    </button>
                  </div>
                </form>
              </section>
            </>
          ) : (
            <>
              <section className="chartBox_area">
                <input
                  type="text"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    marginBottom: "10px",
                    padding: "8px",
                    width: "250px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                />
                <DataTable
                  // data={colleges}
                  data={filteredData}
                  columns={columns}
                  pagination
                  responsive
                  highlightOnHover
                  customStyles={customStyles}
                />
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageCollegeUniversity;
